
import {CSSProperties, FC} from 'external/react'

import getImage from 'resources/assets'

type CourseCoverProps = {
    id: string
    name?: string
    className?: string
    style?: CSSProperties
}

const defaultCover = getImage('/illustrations/default-cover.jpg') as string

const CourseCover: FC<CourseCoverProps> = props => {
    const {id, name, className, style} = props
    return (<img
        className={className}
        style={style}
        src={`https://static.edufile.net/covers/${id}.jpg`}
        alt={name}
        onError={(e) => { (e.target as HTMLImageElement).src = defaultCover }} />
    )
}
export {CourseCover as default}